<template>
  <a-card :bordered="false" class="m-t-10">
    <p class="fz-16 s_font_b p-b-20">
      <a-button class="m-r-10" size='small' @click="()=>{$router.go(-1)}">
        <LeftOutlined />返回
      </a-button>
      创建入库单
    </p>
    <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item label="入库单号" name='warehousing_sn'>{{form.warehousing_sn}}</a-form-item>
      <a-form-item label="入库仓库" name='warehouse_id'>
        <a-select v-model:value="form.warehouse_id" style='width: 40%;' placeholder='请选择仓库' @change='selectChange' :disabled="$route.query.type == 'edit' || isDisabled">
          <a-select-option v-for='item in warehouseList' :key='item.id' :value="item.id">{{item.name}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="库位" name='position_id'>
        <a-select v-model:value="form.position_id" style='width: 40%;' placeholder='请选择库位' :disabled="!form.warehouse_id || $route.query.type == 'edit' || isDisabled" >
          <a-select-option v-for='item in warehouseChild' :key='item.id' :value="item.id">{{item.name}}
          </a-select-option>
        </a-select>
        <a-button class='m-l-10' @click='form.position_id = null' :disabled="!form.warehouse_id || $route.query.type == 'edit' || isDisabled">清空</a-button>
      </a-form-item>
      <a-form-item label="使用生产批次入库" name='use_product_batch'>
        <a-radio-group v-model:value="form.use_product_batch" @change='radioChange' :disabled="$route.query.type == 'edit' || isDisabled">
          <a-radio :value="0">否</a-radio>
          <a-radio :value="1">是</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label='生产批次' v-if='form.use_product_batch == 1' name='product_batch_id'>
        <a-input style="width: 480px;margin-right: 10px;" readonly v-model:value="form.product_batch_name" placeholder='请选择生产批次'></a-input>
        <a-button type="primary" @click="showBatch = true" :disabled="$route.query.type == 'edit' || isDisabled">选择</a-button>
      </a-form-item>
      <a-form-item label="商品名称" name='product_name'>
          <a-input-group compact style="width: 480px;margin-right: 10px;">
            <a-input style="width: 120px" v-model:value="form.product_sku_sn_name" placeholder='商品编号' readonly />
            <a-input style="width: 360px;" readonly v-model:value="form.product_name" placeholder='请选择商品'/>
          </a-input-group>
          <a-button type="primary" @click="showGood = true" :disabled="form.use_product_batch == 1 || $route.query.type == 'edit' || isDisabled" >选择</a-button>
      </a-form-item>
      <a-form-item label="入库数量" name='warehousing_num'>
         <a-input-number  v-model:value="form.warehousing_num" style='width: 40%;' :precision='0' :min="0" placeholder='请输入数量'></a-input-number>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 10, offset: 3}">
        <a-button class="width-100 m-r-20" block @click="()=>{$router.go(-1)}">取消</a-button>
        <a-button class="width-100 m-r-20" block @click="onSubmit">生成入库单</a-button>
      </a-form-item>
    </a-form>
  </a-card>
  <a-modal  :keyboard="false" title="选择商品" v-model:visible="showGood" centered :width='1300' :footer="null" destroyOnClose>
    <selectGood v-on:select="goodSelect" :selectList='[{id:form.product_id}]' :checkout="false" :skuType='true'></selectGood>
  </a-modal>
  <a-modal  :keyboard="false" title="选择生产批次" v-model:visible="showBatch" centered :width='1300' :footer="null" destroyOnClose>
    <selectGoodBatch v-on:select="batchSelect" :selectList='[{id:form.batch_id}]' :checkout="false"></selectGoodBatch>
  </a-modal>
</template>

<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { LeftOutlined } from "@ant-design/icons-vue";
  import { message } from "ant-design-vue";
  import { iscode } from "@/utils/app";
  import { getWarehouseList,getWarehousingSn,addWarehousing,getWarehousingMore,createDocumentWarehousing } from '@/api/antiFleeing';
  import store from "@/store";
  let defForm = {
    warehousing_sn: '',
    warehouse_id: null,
    position_id: null,
    use_product_batch: 0,
    product_batch_id:'',
    product_id:'',
    product_sku_sn:'',
    scan_type:1,
    warehousing_num:''
  };
  export default {
    components: { LeftOutlined },
    setup() {
      const ruleForm = ref();
      const form = ref({ ...defForm });
      const state = reactive({
        labelCol: {span: 3},
        wrapperCol: {span: 12},
        warehouseList:[],
        warehouseChild:[],
        showGood:false,
        showBatch:false,
        showResult:false,
        scanCodeNum:0, //扫码数量
        successNum:0, // 成功数量
        successGoodsNum:0, //成功商品数量
        resultCode:'', //扫码结果code
        resultMsg:'', // 扫码结果提示语
        isDisabled:false, // 扫码成功禁用一些选项
        rules: {
          warehousing_sn: [
            { required: true, message: '入库单号不能为空'}
          ],
          warehouse_id: [
            { required: true, message: '请选择入库仓库',type:'number'}
          ],
          product_batch_id: [
            { required: true, message: '请选择生产批次'}
          ],
          product_name: [
            { required: true, message: '请选择商品'}
          ],
          scan_type:[
            { required: true,  message: '请选择扫码类型',type:'number'}
          ],
          warehousing_num:[
            { required: true,  message: '入库数量不能为空',}
          ],
        }
      });
      const $route = inject("$route");
      const $Modal = inject("$Modal");
      const $router = inject("$router");
      // 获取仓库
      const getWarehouse = async () => {
        let res = await getWarehouseList().then(res => res.data);
        if (iscode(res)) {
          state.warehouseList = res.data;
                   // 默认选择默认仓库
          form.value.warehouse_id=res.data[0].id
        } else {
          message.error(res.msg);
        }
      }
      // 生成入库单号
      const warehousingSnGet = async () => {
        let res = await getWarehousingSn().then(res => res.data);
        if (iscode(res)) {
          form.value.warehousing_sn = res.data.sn;
        } else {
          message.error(res.msg);
        }
      }
      //选择仓库
      const selectChange = () =>{
        form.value.position_id = null
        var item = state.warehouseList.find(v => v.id == form.value.warehouse_id)
        state.warehouseChild = item.child || []
      }
      // 是否使用生产批次切换
      const radioChange = () => {
        form.value.product_id = ''
        form.value.product_name = ''
        form.value.product_sku_sn = ''
        form.value.product_sku_sn_name = ''
        form.value.product_batch_id = ''
        form.value.product_batch_name = ''
      }
      //选择商品
      const goodSelect = (e) =>{
        form.value.product_id = e.id
        form.value.product_name = (e.product_sku_name?e.product_sku_name:'单规格')+' - '+e.product_name
        form.value.product_sku_sn = e.product_sku_sn || 0
        form.value.product_sku_sn_name = e.product_sku_sn || e.product_sn
        state.showGood = false
      }
      //选择批次
      const batchSelect = (e) =>{
        form.value.product_id = e.product_id
        form.value.product_name = (e.product_sku_name?e.product_sku_name:'单规格')+' - '+e.product_name
        form.value.product_sku_sn = e.product_sku_sn || 0
        form.value.product_sku_sn_name = e.product_sku_sn || e.product_sn
        form.value.product_batch_id = e.id
        form.value.product_batch_name = e.batch_name
        state.showBatch = false
      }
  
      //提交
      const onSubmit = () => {
        ruleForm.value.validate().then(async() => {
          const hide = message.loading("正在加载中...", 0);
          let res = await createDocumentWarehousing({ ...form.value}).then((res) => res.data).catch(error => error);
          if (iscode(res,true)) {
              $router.go(-1)
          } else {
            message.error(res.msg);
          }
          setTimeout(hide);
        }).catch(error => {
          message.error('请完善表单！');
        });
      };
      onMounted(() => {
        getWarehouse()
        warehousingSnGet();
      });
      return {
        form,
        ruleForm,
        ...toRefs(state),
        onSubmit,
        selectChange,
        goodSelect,
        batchSelect,
        radioChange
      };
    },
  };
</script>